import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Container, Box, Paper, Typography, FormControl, Tooltip, InputLabel, Select, Modal, Snackbar, Alert, MenuItem, TextField, Button, Checkbox, FormControlLabel,
    Grid, Divider
} from '@mui/material';
import {
    DirectionsBus, ConfirmationNumber, EventSeat, LocalGasStation, AccountBox, Business, CalendarToday, CheckCircle, Save, Refresh, Cancel
} from '@mui/icons-material';

const AddVehicle = () => {
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [registrationNo, setRegistrationNo] = useState("");
    const [selectedVehicleType, setSelectedVehicleType] = useState('');
    const [make, setMake] = useState("");
    const [makeNo, setMakeNo] = useState("");
    const [model, setModel] = useState("");
    const [reading, setReading] = useState("");
    const [engineNo, setEngineNo] = useState("");
    const [seatingCapacity, setSeatingCapacity] = useState('');
    const [fuelType, setFuelType] = useState("");
    const [chassesNo, setChassesNo] = useState("");
    const [rentCharges, setRentCharges] = useState('');
    const [transporterName, setTransporterName] = useState("");
    const [transporterPhone, setTransporterPhone] = useState("");
    const [transporterAddress, setTransporterAddress] = useState("");
    const [insCompany, setInsCompany] = useState("");
    const [insAgent, setInsAgent] = useState("");
    const [agentPhone, setAgentPhone] = useState("");
    const [amountInsured, setAmountInsured] = useState('');
    const [permitNo, setPermitNo] = useState("");
    const [permitType, setPermitType] = useState("");
    const [selectedDriver, setSelectedDriver] = useState('');

    const today = new Date().toISOString().split('T')[0];
    const [dateOfManufacturing, setDateOfManufacturing] = useState(today);
    const [dateInsured, setDateInsured] = useState(today);
    const [insuranceDueOn, setInsuranceDueOn] = useState(today);
    const [permitDate, setPermitDate] = useState(today);
    const [policyExpDate, setPolicyExpDate] = useState(today);
    const [pollExpDate, setPollExpDate] = useState(today);
    const [isActive, setIsActive] = useState(true);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarType, setSnackbarType] = useState("success");
const { vehicleType = [], driverList, onSaveSuccess, onCancel, encodedFormId } = location.state || {};

    const onSaveSuccessMsg = (message) => {
        setSnackbarType("success");
        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };

    const onSaveErrorMsg = (message) => {
        setSnackbarType("error");
        setSnackbarMessage(message);
        setSnackbarOpen(true);
    };

    const handleSave = async () => {
        if (!vehicleNumber.trim()) {
            onSaveErrorMsg("Vehicle number is required.");
            return;
        }
        if (!registrationNo.trim()) {
            onSaveErrorMsg("Registration number is required.");
            return;
        }
        if (!selectedVehicleType) {
            onSaveErrorMsg("Vehicle type is required.");
            return;
        }
        if (!seatingCapacity.trim()) {
            onSaveErrorMsg("Seating capacity is required.");
            return;
        }
        if (isNaN(seatingCapacity) || parseInt(seatingCapacity) <= 0) {
            onSaveErrorMsg("Seating capacity must be a positive number.");
            return;
        }
        if (rentCharges && parseFloat(rentCharges) < 0) {
            onSaveErrorMsg("Rent charges cannot be negative.");
            return;
        }
        if (amountInsured && parseFloat(amountInsured) < 0) {
            onSaveErrorMsg("Amount insured cannot be negative.");
            return;
        }
        if (reading && parseFloat(reading) < 0) {
            onSaveErrorMsg("Reading cannot be negative.");
            return;
        }

        const vehicleData = {
            registrationNo: registrationNo.trim(),
            vechileNo: vehicleNumber.trim(),
            make: make || "DEFAULT_MAKE",
            makeNo: makeNo || "DEFAULT_MAKE",
            model: model || "",
            reading: reading || "0",
            engineNo: engineNo || "DEFAULT_ENGINE",
            dateOfMfg: dateOfManufacturing,
            seatingCapicity: parseInt(seatingCapacity),
            fuelType: fuelType || "Petrol",
            chassesNo: chassesNo || "CHASSIS_DEFAULT",
            rentCharges: parseFloat(rentCharges) || 0,
            transporterName: transporterName || "DEFAULT_TRANSPORTER",
            transporterPhone: transporterPhone || "0000000000",
            transporterAdress: transporterAddress || "N/A",
            insCompany: insCompany || "DEFAULT_INSURANCE",
            insAgent: insAgent || "DEFAULT_AGENT",
            agentphone: agentPhone || "0000000000",
            amountInsured: parseFloat(amountInsured) || 0,
            dateInsured: dateInsured,
            insDueOn: insuranceDueOn,
            permitNo: permitNo || "N/A",
            permitType: permitType || "ANNUAL",
            permitDate: permitDate,
            policyExpdate: policyExpDate,
            pollExpdate: pollExpDate,
            vechileOn: isActive,
            vechileTypeId: selectedVehicleType
        };

        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(`${apiUrl}/Transportation/VehicleMaster`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: sessionStorage.getItem('token'),
                },
                body: JSON.stringify(vehicleData)
            });

            const result = await response.json();

            if (!response.ok) {
                const errorMessage = result?.msg || `HTTP error! status: ${response.status}`;
                throw new Error(errorMessage);
            }
            setShowSuccessModal(true);
            onSaveSuccessMsg("Vehicle added successfully!");
            // Check if onSaveSuccess is a function before calling it
            if (typeof onSaveSuccess === 'function') {
                onSaveSuccess("Vehicle added successfully!");
            } else {
                console.warn("onSaveSuccess is not a function or is undefined");
            }
        } catch (error) {
            console.error("Error saving vehicle:", error);
            onSaveErrorMsg(error.message || "Failed to save vehicle.");
        }
    };

    const resetForm = () => {
        setVehicleNumber('');
        setRegistrationNo('');
        setSelectedVehicleType('');
        setMake('');
        setMakeNo('');
        setModel('');
        setReading('');
        setEngineNo('');
        setSeatingCapacity('');
        setFuelType('');
        setChassesNo('');
        setRentCharges('');
        setTransporterName('');
        setTransporterPhone('');
        setTransporterAddress('');
        setInsCompany('');
        setInsAgent('');
        setAgentPhone('');
        setAmountInsured('');
        setPermitNo('');
        setPermitType('');
        setDateOfManufacturing('');
        setDateInsured('');
        setInsuranceDueOn('');
        setPermitDate('');
        setPolicyExpDate('');
        setPollExpDate('');
        setIsActive(false);
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Box
                sx={{
                    backgroundColor: '#0B1F40',
                    padding: '16px 24px',
                    boxShadow: 3,
                    borderRadius: '8px 8px 0 0',
                    marginBottom: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}
            >
                <DirectionsBus sx={{ color: '#fff', fontSize: 28 }} />
                <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
                    Add New School Vehicle
                </Typography>
            </Box>

            <Paper elevation={3} sx={{ p: 4, borderRadius: '0 0 8px 8px', backgroundColor: '#fafafa' }}>
                <Grid container spacing={3}>
                    {/* Vehicle Details Section */}
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2, color: '#0B1F40', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <DirectionsBus sx={{ color: '#0B1F40' }} /> Vehicle Details
                        </Typography>
                        <Divider sx={{ mb: 3 }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ConfirmationNumber sx={{ color: '#0B1F40' }} /> Registration Number <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Registration Number"
                            value={registrationNo}
                            onChange={(e) => setRegistrationNo(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <DirectionsBus sx={{ color: '#0B1F40' }} /> Vehicle Number <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Vehicle Number"
                            value={vehicleNumber}
                            onChange={(e) => setVehicleNumber(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Vehicle Type <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="vehicle-type-label">Select Vehicle Type</InputLabel>
                           <Select
    labelId="vehicle-type-label"
    value={selectedVehicleType}
    onChange={(e) => setSelectedVehicleType(e.target.value)}
    label="Select Vehicle Type"
    sx={{ backgroundColor: "#fff" }}
>
    <MenuItem value="" disabled>--Select Vehicle Type--</MenuItem>
    {Array.isArray(vehicleType) && vehicleType.map((type) => (
        <MenuItem key={type.vehicleTypeId} value={type.vehicleTypeId}>
            {type.vehicleType}
        </MenuItem>
    ))}
</Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Make
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Make"
                            value={make}
                            onChange={(e) => setMake(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Make Number
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Make Number"
                            value={makeNo}
                            onChange={(e) => setMakeNo(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Model
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Model"
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Reading
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Reading"
                            value={reading}
                            onChange={(e) => setReading(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Engine Number
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Engine Number"
                            value={engineNo}
                            onChange={(e) => setEngineNo(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <EventSeat sx={{ color: '#0B1F40' }} /> Seating Capacity <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Seating Capacity"
                            type="number"
                            value={seatingCapacity}
                            onChange={(e) => setSeatingCapacity(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <LocalGasStation sx={{ color: '#0B1F40' }} /> Fuel Type
                        </Typography>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="fuel-type-label">Select Fuel Type</InputLabel>
                            <Select
                                labelId="fuel-type-label"
                                value={fuelType}
                                onChange={(e) => setFuelType(e.target.value)}
                                label="Select Fuel Type"
                                sx={{ backgroundColor: "#fff" }}
                            >
                                <MenuItem value="">--Select Fuel Type--</MenuItem>
                                <MenuItem value="Petrol">Petrol</MenuItem>
                                <MenuItem value="Diesel">Diesel</MenuItem>
                                <MenuItem value="CNG">CNG</MenuItem>
                                <MenuItem value="Electric">Electric</MenuItem>
                                <MenuItem value="Hybrid">Hybrid</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Chassis Number
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Chassis Number"
                            value={chassesNo}
                            onChange={(e) => setChassesNo(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Rent Charges
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Rent Charges"
                            type="number"
                            value={rentCharges}
                            onChange={(e) => setRentCharges(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>

                    {/* Transporter Information Section */}
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: '#0B1F40', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <AccountBox sx={{ color: '#0B1F40' }} /> Transporter Information
                        </Typography>
                        <Divider sx={{ mb: 3 }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Transporter Name
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Transporter Name"
                            value={transporterName}
                            onChange={(e) => setTransporterName(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Transporter Phone
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Transporter Phone"
                            inputProps={{ maxLength: "10" }}
                            value={transporterPhone}
                            onChange={(e) => setTransporterPhone(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Transporter Address
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Transporter Address"
                            multiline
                            rows={2}
                            value={transporterAddress}
                            onChange={(e) => setTransporterAddress(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>

                    {/* Insurance Details Section */}
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: '#0B1F40', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Business sx={{ color: '#0B1F40' }} /> Insurance Details
                        </Typography>
                        <Divider sx={{ mb: 3 }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Insurance Company
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Insurance Company"
                            value={insCompany}
                            onChange={(e) => setInsCompany(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Insurance Agent
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Insurance Agent"
                            value={insAgent}
                            onChange={(e) => setInsAgent(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Agent Phone
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Agent Phone"
                            inputProps={{ maxLength: '10' }}
                            value={agentPhone}
                            onChange={(e) => setAgentPhone(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Amount Insured
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Amount Insured"
                            type="number"
                            value={amountInsured}
                            onChange={(e) => setAmountInsured(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Date Insured
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={dateInsured}
                            onChange={(e) => setDateInsured(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Insurance Due On
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={insuranceDueOn}
                            onChange={(e) => setInsuranceDueOn(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>

                    {/* Permit Details Section */}
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold', mt: 4, mb: 2, color: '#0B1F40', display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ConfirmationNumber sx={{ color: '#0B1F40' }} /> Permit Details
                        </Typography>
                        <Divider sx={{ mb: 3 }} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <ConfirmationNumber sx={{ color: '#0B1F40' }} /> Permit Number
                        </Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Enter Permit Number"
                            value={permitNo}
                            onChange={(e) => setPermitNo(e.target.value)}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1 }}>
                            Permit Type
                        </Typography>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel id="permit-type-label">Select Permit Type</InputLabel>
                            <Select
                                labelId="permit-type-label"
                                value={permitType}
                                onChange={(e) => setPermitType(e.target.value)}
                                label="Select Permit Type"
                                sx={{ backgroundColor: "#fff" }}
                            >
                                <MenuItem value="">--Select Permit Type--</MenuItem>
                                <MenuItem value="ANNUAL">Annual</MenuItem>
                                <MenuItem value="TEMPORARY">Temporary</MenuItem>
                                <MenuItem value="PERMANENT">Permanent</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Permit Date
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={permitDate}
                            onChange={(e) => setPermitDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Policy Expiry Date
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={policyExpDate}
                            onChange={(e) => setPolicyExpDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Pollution Expiry Date
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={pollExpDate}
                            onChange={(e) => setPollExpDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                            <CalendarToday sx={{ color: '#0B1F40' }} /> Date of Manufacturing
                        </Typography>
                        <TextField
                            type="date"
                            fullWidth
                            variant="outlined"
                            value={dateOfManufacturing}
                            onChange={(e) => setDateOfManufacturing(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            sx={{ backgroundColor: "#fff", borderRadius: "4px" }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isActive}
                                    onChange={(e) => setIsActive(e.target.checked)}
                                    color="primary"
                                    icon={<CheckCircle />}
                                    checkedIcon={<CheckCircle sx={{ color: '#0B1F40' }} />}
                                />
                            }
                            label="Is Active"
                            sx={{ mt: 2 }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                            <Tooltip title={(!registrationNo || !vehicleNumber || !vehicleType || !seatingCapacity) && "Please fill the required fields"} arrow>
                                <span>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<Save />}
                                        onClick={handleSave}
                                        disabled={!registrationNo || !vehicleNumber || !vehicleType || !seatingCapacity}
                                        sx={{ px: 4, py: 1.5, fontWeight: 'bold', textTransform: 'none' }}
                                    >
                                        Save
                                    </Button>
                                </span>
                            </Tooltip>
                            <Button
                                variant="outlined"
                                color="secondary"
                                startIcon={<Refresh />}
                                onClick={resetForm}
                                sx={{ px: 4, py: 1.5, textTransform: 'none' }}
                            >
                                Reset
                            </Button>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<Cancel />}
                                onClick={() => navigate(-1)}
                                sx={{ px: 4, py: 1.5, textTransform: 'none' }}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>

            <Modal
                open={showSuccessModal}
                onClose={() => setShowSuccessModal(false)}
                aria-labelledby="success-modal-title"
                aria-describedby="success-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CheckCircle sx={{ color: '#fff' }} />
                        <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
                            Vehicle Added
                        </Typography>
                    </Box>
                    <Box sx={{ p: 3 }}>
                        <Typography id="success-modal-description" sx={{ mb: 3 }}>
                            The vehicle has been added successfully.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                onClick={() => {
                                    setShowSuccessModal(false);
                                    navigate(-1);
                                }}
                                variant="contained"
                                color="primary"
                                startIcon={<CheckCircle />}
                                sx={{ px: 4, textTransform: 'none' }}
                            >
                                OK
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert severity={snackbarType} onClose={() => setSnackbarOpen(false)}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default AddVehicle;